import React, { useState } from 'react';
import { TextField, Button, Alert, CircularProgress, InputAdornment, IconButton, Box, Typography } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { UseAuthFormReturn } from '../../types/form';
import { Link } from 'react-router-dom';

interface LoginFormProps {
    formState: UseAuthFormReturn;
}

export const LoginForm: React.FC<LoginFormProps> = ({ formState }) => {
    const { formData, error, loading, handleInputChange, handleLogin } = formState;
    const [showPassword, setShowPassword] = useState(false);

    const handleTogglePasswordVisibility = () => {
        setShowPassword((prevShowPassword) => !prevShowPassword);
    };

    return (
        <form onSubmit={handleLogin}>
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
            <TextField
                name="email"
                label="Email"
                value={formData.email}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
            />
            <TextField
                name="password"
                type={showPassword ? "text" : "password"}
                label="Password"
                value={formData.password}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleTogglePasswordVisibility}
                                edge="end"
                            >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                <Typography 
                    component={Link} 
                    to="/forgot-password" 
                    variant="body2" 
                    color="primary"
                    sx={{ textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
                >
                    Forgot Password?
                </Typography>
            </Box>
            <Button 
                type="submit" 
                variant="contained" 
                color="primary" 
                fullWidth 
                disabled={loading}
            >
                {loading ? <CircularProgress size={24} color="inherit" /> : 'Login'}
            </Button>
        </form>
    );
};

export default LoginForm;
